module.exports = __webpack_public_path__ + "img/上海市科技小巨人.ba57b95b.jpg";